import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GeneralService } from '../../../services/general/general.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['../../../../shared-styles/settings.scss'],
})
export class ProfileComponent implements OnInit, OnDestroy {
  public isMobile: any;
  public headerHeight: any = 0;
  public loading: any = false;
  public subscriptions: any = [];

  constructor(
    public general: GeneralService,
    private cdRef: ChangeDetectorRef
  ) {
    this.isMobile = this.general.isMobile();
  }

  ngOnInit() {
    // if (environment.production) {
    //   this.general.showInfiniteWarning('web-under-construction');
    // }
    this.intializeSubscriptions();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription: any) => {
      subscription.unsubscribe();
    });
  }

  intializeSubscriptions() {
    this.subscriptions = [
      this.general.loading$.subscribe((res) => (this.loading = res)),
    ];
  }

  /**
   * =================== Sidebar ===================
   */
  onGetHeight(height: any) {
    if (height) {
      this.headerHeight = height;
    }
  }
  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }
}
